import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useGame } from '../../context/GameContext';
import './TurnManagement.css';

const GameCompleted = () => {
  const { gameState } = useGame();
  const navigate = useNavigate();

  // Only show this component when game state is completed
  if (gameState !== 'completed') {
    return null;
  }

  return (
    <div className="turn-management-section">
      <div className="game-completed-section">
        <h3>Game Completed!</h3>
        <p>Congratulations! You have completed all eras and created a new language!</p>
        <button 
          className="return-home-btn" 
          onClick={() => navigate('/')}
        >
          Return to Home
        </button>
      </div>
    </div>
  );
};

export default GameCompleted; 